export const shop = state => {
    return state.shop;
};

export const productsLog = state => {
    return state.productsLog;
};

export const blog = state => {
    return state.blog;
};

export const cart = state => {
    return state.cart;
};


// WEBPACK FOOTER //
// ./src/store/modules/squarespace/getters.js